<template>
  <div class="main-content">
    <div class="container cv-content">
      <div class="cv-element" v-for="e in contents">
        <h3 style="margin-bottom: 12px" data-toggle="tooltip" data-placement="right" title="test">{{e.title}}</h3>

        <table class="table table-borderless table-sm" v-if="e.type === 'table' || e.type === 'listed-table'">
          <tr v-for="row in e.content">
            <td :class="e.style_title" v-html="'&blacksquare; ' + row[0]" v-if="e.type === 'listed-table'"></td>
            <td :class="e.style_title" v-html="row[0]" v-else></td>
            <td :class="e.style_content" v-html="row[1]"></td>
          </tr>
        </table>
        <table class="table table-borderless table-sm" v-else-if="e.type === 'exp-table'">
          <tr v-for="row in e.content">
            <td :class="e.style_title">{{row.date}}</td>
            <td :class="e.style_content">
              <span v-html="row.title"></span>
              <span class="badge badge-rounded bgc-research" v-if="row.icon && row.icon.includes('researcher')">researcher</span>
              <span class="badge badge-rounded bgc-developer" v-if="row.icon && row.icon.includes('developer')">developer</span>
              <span class="badge badge-rounded bgc-maker" v-if="row.icon && row.icon.includes('maker')">maker</span>
              <span class="badge badge-rounded bgc-instructor" v-if="row.icon && row.icon.includes('instructor')">instructor</span>
            </td>
          </tr>
        </table>
        <table class="table table-borderless table-sm" v-else-if="e.type === 'work'">
          <tr v-for="row in e.content">
            <td class="work-date" v-html="row.date"></td>
            <td :class="e.style_content">
              <span class="work-at">{{row.at}}</span> <br>
              <span class="work-position">
                {{row.position}}
              </span>
              <span class="badge badge-rounded bgc-research" v-if="row.icon && row.icon.includes('researcher')">researcher</span>
              <span class="badge badge-rounded bgc-developer" v-if="row.icon && row.icon.includes('developer')">developer</span>
              <span class="badge badge-rounded bgc-maker" v-if="row.icon && row.icon.includes('maker')">maker</span>
              <span class="badge badge-rounded bgc-instructor" v-if="row.icon && row.icon.includes('instructor')">instructor</span>
              <br>
            </td>
          </tr>
        </table>
        <ul v-else-if="e.type === 'obj-list'">
          <li class="publication-row" v-for="row in e.content">
            <span style="margin-right: 3px">
              {{row.prize}}, {{row.at}}, {{row.by}}, {{row.date}}
            </span>
            <span class="badge badge-rounded bgc-research" v-if="row.icon && row.icon.includes('researcher')">researcher</span>
            <span class="badge badge-rounded bgc-developer" v-if="row.icon && row.icon.includes('developer')">developer</span>
            <span class="badge badge-rounded bgc-maker" v-if="row.icon && row.icon.includes('maker')">maker</span>
            <span class="badge badge-rounded bgc-instructor" v-if="row.icon && row.icon.includes('instructor')">instructor</span>
          </li>
        </ul>
        <ul v-else-if="e.type === 'list'">
          <li v-for="row in e.content" class="info-list-row">
            <span :class="e.style_title" v-html="row[0]"></span>
            <span :class="e.style_content" v-html="row[1]"></span>
          </li>
        </ul>
        <div v-else>
          <p v-for="row in e.content">
            <span :class="e.style_title" v-html="row[0]"></span>
            <span :class="e.style_content" v-html="row[1]"></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Experiences',
  components: {},
  data() {
    return {
      contents: [
        {
          order: 1000,
          type: 'exp-table',
          title: "Projects",
          style_title: "info-bold",
          style_content: "info-regular",
          content: [
            {
              date: "Apr. 2013  ~ Mar. 2014",
              title: "Participated in a project research <br>「Development of Stand-alone Star Finder」as a team leader, Team「FinApple」 ",
              icon: ["researcher", "maker"]
            },
            {
              date: "Sep. 2013  ~ Nov. 2013",
              title: "Participated in a project research <br>「3D Floor Heating System and Its Efficiency」as a team leader. ",
              icon: ["researcher"]
            },
            {
              date: "Jul. 2016  ~ Oct. 2016",
              title: "Participated in 6th National Science Museum Idea Club <br>「Drowsiness-Prevention Bracelet Device」",
              icon: ["maker"]
            },
            {
              date: "Jul. 2016  ~ Nov. 2016",
              title: "Participated in Idea Cooking 2016, College of Engineering, KAIST.<br> Team 「Music, lights the glasses」",
              icon: ["maker"]
            },
            {
              date: "Jul. 2016  ~ Dec. 2016",
              title: "Participated in 6th National Science Museum Idea Club as a team leader.<br>「Bi:Um」 ― Umbrella supporting device for vehicles, Team WingDev.<br>Selected as a patent supporting project. (10-2016-0172170)",
              icon: ["maker"]
            },
            {
              date: "Jan. 2018  ~ Feb. 2018 ",
              title: "Participated in 2nd KAIST Idea Factory MAKER club 「GrabCon」",
              icon: ["maker"]
            },
          ]
        },
        {
          order: 1200,
          type: 'exp-table',
          title: "Extracurricular Experiences",
          style_title: "info-bold",
          style_content: "info-regular",
          content: [
            {
              date: "Dec. 2016  ~ Nov. 2017",
              title: "Project Manager (Director, Education department), KAIST Robotics Club MR.<br>Teaching basic robotics for newcomers & managing seminars and projects.",
              icon: ["maker"]
            },
            {
              date: "Aug. 2017",
              title: "2017 Research Officers for National Defense Cadet ADD Internship (40 hours)"
            },
            {
              date: "Dec. 2017  ~ Dec. 2018",
              title: "President, KAIST Robotics&Maker Club MR.",
              icon: ["maker"]
            },
            {
              date: "Feb. 2018",
              title: "2018 Research Officers for National Defense Cadet ADD Internship (40 hours)"
            },
            {
              date: "Sep. 2018  ~ Feb. 2019",
              title: "Participated in KAIST Idea Factory 2018 MAKER LABS",
              icon: ["maker"]
            },
          ]
        },
        {
          order: 1300,
          type: 'work',
          title: "Activities",
          style_title: "info-bold",
          style_content: "info-regular",
          content: [
            {
              date: "Jan. 2016",
              at: "Dream Mentoring Camp, KAIST Midam Scholarship Association ",
              position: "Mentor",
              icon: ["instructor"]
            },
            {
              date: "Mar. 2016  ~ Jun. 2016",
              at: "KAIST Freshmen Tutoring Program",
              position: "Tutor (General Biology)",
              icon: ["instructor"]
            },
            {
              date: "Aug. 2016",
              at: "H Science Camp, KAIST Midam Scholarship Association & Hyundai Steel",
              position: "Mentor",
              icon: ["instructor"]
            },
            {
              date: "Jan. 2017",
              at: "KAIST YOUTH Scientist Camp, KAIST Global Institute for Talented Education",
              position: "Tutor, Contents creator",
              icon: ["instructor", "developer"]
            },
            {
              date: "Jan. 2018",
              at: "KAIST YOUTH Scientist Camp, KAIST Global Institute for Talented Education",
              position: "Tutor, Contents creator",
              icon: ["instructor", "developer"]
            },
            {
              date: "Jun. 2018  ~ Aug. 2018",
              at: "KAIST SW Camp, KAIST Center for SW Education & KAIST GIFTED",
              position: "Planner, Contents creator, Manager, Tutor",
              icon: ["instructor", "developer"]
            },
            {
              date: "Aug. 2018",
              at: "KAIST YOUTH Scientist Camp, KAIST Global Institute for Talented Education",
              position: "Tutor",
              icon: ["instructor", "developer"]
            },
            {
              date: "Nov. 2018  ~ Dec. 2018",
              at: "KAIST SW Camp, KAIST Center for SW Education & KAIST GIFTED",
              position: "Planner, Contents Developer, Manager, Tutor",
              icon: ["instructor", "developer"]
            },
          ]
        },
        {
          order: 1500,
          type: 'obj-list',
          title: "Awards",
          style_title: "info-regular",
          style_content: "info-regular",
          content: [
            {
              date: "Oct. 2013",
              at: "28th Seoul Student Research and Presentation Contest",
              by: "Seoul Science Park",
              prize: "1st Prize",
              icon: ["researcher"]
            },
            {
              date: "Feb. 2014",
              at: "20th HumanTech Paper Award",
              by: "Samsung Electronics",
              prize: "Selected (Physics/Earth Science)",
              icon: ["researcher"]
            },
            {
              date: "Apr. 2014",
              at: "55th Seoul Science Fair",
              by: "Seoul Metropolitan Office of Education",
              prize: "3rd Prize",
              icon: ["researcher"]
            },
            {
              date: "Aug. 2018",
              at: "Excellent lecture in Humanity/Leadership III course",
              by: "KAIST Global Leadership Center",
              prize: "3rd Prize",
              icon: ["instructor"]
            }
          ]
        },
      ]}
  }
}
</script>

<style>
#app {
}
body {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Experiences.vue